import { ElementType } from '@apeiron/planet'
import { styled } from '@mui/material'
import { getElementTKey } from '@src/util/apeiron/planet'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const TagBase = styled('div')`
  width: 40px;
  border-radius: 6px;
  color: #ffffff;
  font-size: 12px;
  line-height: 14px;
  font-weight: 700;
  text-align: center;
`

const FireTag = styled(TagBase)`
  background-color: #c04d32;
`

const WaterTag = styled(TagBase)`
  background-color: #3e80b8;
`

const AirTag = styled(TagBase)`
  background-color: #508d38;
`

const EarthTag = styled(TagBase)`
  background-color: #797670;
`

export const ElementTag: React.FC<ElementTagProps> = props => {
  const { className, element } = props

  const { t } = useTranslation()

  return (
    <div className={className}>
      {element === ElementType.Fire && (
        <FireTag>{t(getElementTKey(ElementType.Fire))}</FireTag>
      )}
      {element === ElementType.Water && (
        <WaterTag>{t(getElementTKey(ElementType.Water))}</WaterTag>
      )}
      {element === ElementType.Air && (
        <AirTag>{t(getElementTKey(ElementType.Air))}</AirTag>
      )}
      {element === ElementType.Earth && (
        <EarthTag>{t(getElementTKey(ElementType.Earth))}</EarthTag>
      )}
    </div>
  )
}

export type ElementTagProps = {
  className?: string
  element: ElementType
}
